<template>
  <div class="app-container">
    <div class="filter-container">
      <el-input
        v-model="listQuery.keyword"
        placeholder="请输入关键字搜索"
        style="width: 200px"
        class="filter-item"
        clearable
      />
      <el-select
        v-model="listQuery.status"
        placeholder="提现状态"
        style="width: 120px"
        class="filter-item"
        clearable
      >
        <el-option
          v-for="item in applyStatus"
          :key="item.key"
          :label="item.value"
          :value="item.key"
        />
      </el-select>
      <DataPicker
        @valueFunc="getPickerValueFunc"
        startPlaceholder="申请开始时间"
        endPlaceholder="申请截止时间"
      />
      <el-button
        class="filter-item"
        type="primary"
        icon="el-icon-search"
        @click="handleFilter"
        >搜索</el-button
      >
      <!-- <el-button
        class="filter-item"
        type="primary"
        v-if="
          (isAgentLogin != AGENT_LOGIN_ROLE_VAL.AGENT || !disabled) &&
            isAgentLogin != AGENT_LOGIN_ROLE_VAL.AGENT_ADMIN
        "
        @click="handleExport"
        >导出</el-button
      > -->
    </div>

    <el-table
      v-loading="listLoading"
      :data="list"
      element-loading-text="Loading"
      size="small"
      border
      fit
      highlight-current-row
    >
      <el-table-column label="用户名" align="center" prop="userName" />
      <el-table-column label="用户手机号" align="center" prop="userMobile" />
      <el-table-column
        label="币种"
        align="center"
        prop="coinCode"
      ></el-table-column>
      <el-table-column
        label="交易所名称"
        align="center"
        prop="name"
      ></el-table-column>
      <el-table-column label="方向" align="center" prop="direction">
        <template slot-scope="scope">
          {{ scope.row.direction == 1 ? "商城到交易所" : "交易所到商城" }}
        </template>
      </el-table-column>
      <el-table-column label="状态" align="center" prop="status">
        <template slot-scope="scope">
          {{ getStatus(scope.row.status) }}
        </template>
      </el-table-column>
      <el-table-column label="账户类别" align="center" prop="category">
        <template slot-scope="scope">
          {{ getCategory(scope.row.category) }}
        </template>
      </el-table-column>
      <el-table-column
        label="兑换金额(¥)"
        align="center"
        prop="amount"
        width="90"
      >
      </el-table-column>
      <el-table-column
        label="手续费金额(¥)"
        align="center"
        width="90"
        prop="feeAmount"
      ></el-table-column>
      <el-table-column
        label="入账金额(¥)"
        align="center"
        width="90"
        prop="inAmount"
      ></el-table-column>
      <el-table-column label="区块链网络" align="center" prop="network">
      </el-table-column>
      <el-table-column label="更新时间" align="center" prop="mddate">
        <template slot-scope="scope">
          {{ scope.row.mddate | parseTime }}
        </template></el-table-column
      >
      <!-- 
      <el-table-column
        label="操作"
        align="center"
        width="100"
        class-name="small-padding fixed-width"
        v-if="
          (isAgentLogin != AGENT_LOGIN_ROLE_VAL.AGENT || !disabled) &&
            isAgentLogin != AGENT_LOGIN_ROLE_VAL.AGENT_ADMIN
        "
      >
        <template slot-scope="scope">
          <el-button
            type="success"
            size="mini"
            @click="onCancel(scope.row)"
            v-if="scope.row.status == 0"
            >取消</el-button
          >
        </template>
      </el-table-column> -->
    </el-table>

    <div class="pagination-container">
      <el-pagination
        :current-page="listQuery.page"
        :page-size="listQuery.pageSize"
        :total="total"
        background
        layout=" prev, pager, next"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
      />
    </div>
  </div>
</template>

<script>
import { getTableThumbnailImg } from "@/utils/utils";
import { getLogionUserInfo } from "@/utils/auth";
import { AGENT_LOGIN_ROLE_VAL } from "@/utils/enumUtile";
import { uploadXlsx } from "@/utils/index";
import {
  getTbcWithdrawList,
  exportAgentProfitList,
  cancelWithdrawApply
} from "@/api/account-profit";
import DataPicker from "@/views/components/dataPicker.vue";
const APPLY_STATUS = [
  { key: 0, value: "申请中" },
  { key: 1, value: "待交易所确认" },
  { key: 2, value: "交易成功" },
  { key: 3, value: "交易失败" },
  { key: 4, value: "待审核" },
  { key: 5, value: "审核拒绝" }
];
const CATEGORY = [
  { key: "expend", value: "贡献值" },
  { key: "raffle", value: "抽奖次数" },
  { key: "exchange", value: "兑换券" },
  { key: "deduction", value: "抵扣券" },
  { key: "vcoin", value: "交易币" },
  { key: "bonus", value: "推广佣金" },
  { key: "redpacket", value: "现金红包" },
  { key: "balance", value: "现金余额" }
];
export default {
  name: "withdrawalRecords",
  props: {
    agentUserId: {
      type: Number || String
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      list: [],
      total: null,
      listLoading: true,
      listQuery: {
        page: 1,
        pageSize: 10,
        keyword: "",
        status: null,
        applyStartTime: "",
        applyEndTime: ""
      },
      applyStatus: APPLY_STATUS,
      statusMap: new Map(APPLY_STATUS.map(item => [item.key, item.value])),
      categoryMap: new Map(CATEGORY.map(item => [item.key, item.value]))
    };
  },
  created() {
    this.isAgentLogin = getLogionUserInfo().isAgentLogin;
    this.getList();
  },
  filters: {
    parseTime(time) {
      const date = new Date(time);
      return date.toLocaleString("zh-CN");
    }
  },
  methods: {
    getTableThumbnailImg,
    getList() {
      this.listLoading = false;

      this.listQuery.agentUserId = this.agentUserId;
      getTbcWithdrawList(this.listQuery).then(res => {
        this.list = res.data.entitys;
        this.total = res.data.totalCount;
        this.listLoading = false;
      });
    },
    handleFilter() {
      this.listQuery.page = 1;
      this.getList();
    },
    handleSizeChange(val) {
      this.listQuery.pageSize = val;
      this.getList();
    },
    handleCurrentChange(val) {
      this.listQuery.page = val;
      this.getList();
    },
    onCancel(row) {
      console.log(row);
      this.$confirm("确定要取消该提现吗？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then(() => {
        cancelWithdrawApply({ id: row.id, state: 0 }).then(res => {
          console.log(res);
          this.getList();
        });
      });
    },
    handleExport() {
      exportAgentProfitList(this.listQuery).then(res => {
        console.log(res);
        uploadXlsx(res, "提现记录表");
      });
    },
    /**
     * 获取时间
     * @param type
     * @param value
     */
    getPickerValueFunc(type, value) {
      this.listQuery.applyStartTime = value[0];
      this.listQuery.applyEndTime = value[1];
    },
    getStatus(key) {
      return this.statusMap.get(key);
    },
    getCategory(key) {
      return this.categoryMap.get(key);
    }
  },
  computed: {
    AGENT_LOGIN_ROLE_VAL() {
      return AGENT_LOGIN_ROLE_VAL;
    }
  },
  components: {
    DataPicker
  }
};
</script>

<style lang="scss" scoped>
::v-deep .el-image {
  width: 40px;
  height: 40px;
}
</style>
